module.exports = __webpack_public_path__ + "static/media/Niveau_elN2_2_298583.b05f4ebd.png";